import { WebPlugin } from '@capacitor/core';
export class SendIntentWeb extends WebPlugin {
    constructor() {
        super();
    }
    async checkSendIntentReceived() {
        return { title: '' };
    }
    finish() {
    }
}
//# sourceMappingURL=web.js.map